var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"busca-nome-plano"}},[_c('span',{class:_vm.classNome},[_vm._v(" "+_vm._s(_vm.nomePlano))])])
}
var staticRenderFns = []

export { render, staticRenderFns }